module.exports = __webpack_public_path__ + "media/images/account-location-8c1dc5bab3cf1b5423842fd69cc3fee1.svg";